import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { Check, X } from 'lucide-react';
import { mockData } from '../mock';

const ComparisonSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-6xl font-black text-gray-900 mb-6 font-din tracking-tight leading-tight">
            画像撮影より、<br />
            <span className="font-noto-heading text-transparent bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text leading-tight py-2 px-1">3Dモックアップ</span>が選ばれる理由
          </h2>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Traditional Photography - 従来の撮影（目立たない、ネガティブ、小さめ） */}
            <div className="transform scale-95">
              <Card className="bg-gray-50 border-2 border-gray-400 overflow-hidden">
                <CardHeader className="bg-gray-300 text-center py-6">
                  <h3 className="text-xl font-bold text-gray-700">
                    従来の撮影
                  </h3>
                </CardHeader>
              <CardContent className="p-6">
                <div className="space-y-6">
                  {/* 価格 */}
                  <div className="border-b border-gray-200 pb-4">
                    <div className="font-semibold text-gray-700 mb-2">価格</div>
                    <div className="text-gray-600 text-sm">
                      数十万円〜数百万円（撮影費・印刷費・送料含む）
                    </div>
                  </div>
                  
                  {/* 期間 */}
                  <div className="border-b border-gray-200 pb-4">
                    <div className="font-semibold text-gray-700 mb-2">期間</div>
                    <div className="text-gray-600 text-sm">
                      <span className="font-bold">1〜2か月</span>（撮影準備・スタジオ手配含む）
                    </div>
                  </div>
                  
                  {/* 工数 */}
                  <div className="pb-4">
                    <div className="font-semibold text-gray-700 mb-2">工数</div>
                    <div className="text-gray-600 text-sm">
                      撮影準備・移動・撮影・編集が必要
                    </div>
                  </div>
                </div>
              </CardContent>
              </Card>
            </div>

            {/* 3D Mockup - 3Dモックアップ（目立つ、ポジティブ） */}
            <Card className="bg-white border-0 shadow-2xl transform hover:scale-105 transition-transform relative overflow-hidden">
              {/* 背景パターン */}
              <div className="absolute inset-0 opacity-5 pointer-events-none">
                <div className="absolute inset-0" style={{
                  backgroundImage: 'linear-gradient(rgba(76, 175, 80, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(76, 175, 80, 0.1) 1px, transparent 1px)',
                  backgroundSize: '20px 20px'
                }}></div>
              </div>
              
              <CardHeader className="bg-gradient-to-r from-blue-600 to-green-500 text-center py-6 relative">
                <h3 className="text-xl font-bold text-white">
                  3Dモックアップ（4DPocket）
                </h3>
              </CardHeader>
              <CardContent className="p-6 relative">
                <div className="space-y-6">
                  {/* 価格 */}
                  <div className="border-b border-blue-100 pb-4">
                    <div className="font-semibold text-gray-900 mb-3">価格</div>
                    <div className="text-blue-700 text-sm">
                      <span className="font-black text-blue-600 text-4xl">約50,000円</span><span className="text-lg">〜</span>（レンダリング費用のみ）
                    </div>
                  </div>
                  
                  {/* 期間 */}
                  <div className="border-b border-blue-100 pb-4">
                    <div className="font-semibold text-gray-900 mb-3">期間</div>
                    <div className="text-blue-700 text-sm">
                      <span className="font-black text-blue-600 text-2xl">最短1日</span><span className="text-lg">〜2週間</span>（データ入稿から即制作可能）
                    </div>
                  </div>
                  
                  {/* 工数 */}
                  <div className="pb-4">
                    <div className="font-semibold text-gray-900 mb-3">工数</div>
                    <div className="text-blue-700 text-sm font-bold">
                      データ共有のみでOK。修正も即日反映可能
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
          
          {/* 追加メッセージ */}
          <div className="text-center mt-12">
            {/* <p className="text-4xl lg:text-6xl text-gray-900 font-black font-din tracking-tight py-4">
              <span className="text-transparent bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text inline-block pb-2">低コスト・高品質・短納期</span>を<br />
              4DPocketは実現します
            </p> */}
            <p className="text-4xl lg:text-6xl text-gray-900 font-black font-din tracking-tight leading-snug py-4">
              <span className="font-noto-heading text-transparent bg-gradient-to-r from-blue-600 to-green-500 bg-clip-text leading-tight py-2 px-1">低コスト・高品質・短納期</span>
              を<br />
              4DPocketは実現します
            </p>
          </div>   
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;